import { MenuItem, MenuItemProps } from '@chakra-ui/react'

export const ProfileMenuItem = ({ children, ...rest }: MenuItemProps) => {
  return (
    <MenuItem _hover={{ bg: '#805ad5' }} _active={{ bg: '#805ad5' }} _focus={{ bg: '#805ad5' }} {...rest}>
      {children}
    </MenuItem>
  )
}
